import React from "react";
import { Link, Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";

export default function Layout() {
    return (
        <div className="flex min-h-screen flex-col bg-mm-bg text-mm-ink" data-testid="app-layout">
            <a
                href="#main"
                className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-mm-navy focus:px-4 focus:py-2 focus:text-white"
            >
                Skip to content
            </a>
            <Header />
            <main id="main" className="flex-1" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
            <Toaster position="bottom-right" richColors closeButton />
            {/* Export the Link import to silence lint on layouts that may re-export */}
            <span className="hidden">
                <Link to="/" />
            </span>
        </div>
    );
}
